import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCart } from "lucide-react";
import { AMAZON_URL } from "./constants";

export const StickyBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.9);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 90, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 90, opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
          className="fixed inset-x-0 bottom-5 z-50 flex justify-center px-4"
        >
          <div className="flex items-center gap-4 rounded-full border border-linenborder/60 bg-espresso/90 py-2.5 pl-6 pr-2.5 shadow-[0_20px_50px_-15px_rgba(34,26,22,0.5)] backdrop-blur-xl">
            <p className="hidden text-sm text-linen/85 sm:block">
              <span className="font-serif italic">Love the Life You Live</span>
              <span className="mx-2 text-linen/30">·</span>
              <span className="font-semibold text-rose">$12.99</span>
            </p>
            <motion.a
              data-testid="sticky-bottom-buy-now-button"
              href={AMAZON_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Buy the gratitude journal on Amazon (opens in a new tab)"
              whileHover={{ scale: 1.04 }}
              whileTap={{ scale: 0.97 }}
              className="shine-btn inline-flex items-center gap-2 rounded-full bg-terracotta px-5 py-2.5 text-xs font-semibold text-paper transition-colors hover:bg-siennadeep"
            >
              <ShoppingCart size={14} />
              Buy Now
            </motion.a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
